<template>
  <div>
    <div v-if="field.info.multilingual && field.canRead">
      <v-text-field
        v-for="(textLang, index) in contentLanguages"
        :key="index"
        v-model="value[field.fieldName + '_' + textLang.code]"
        :label="labelText + ' (' + textLang.code + ')'"
        :disabled="!field.canEdit"
        :autofocus="field.info.autofocus && textLang.code === language"
        hide-details

        :rounded="cs.inputRounded"
        :dense="cs.inputDense"
        :outlined="cs.inputOutlined"
        :filled="cs.inputFilled"
        :background-color="fieldBackgroundColor(value[field.fieldName + '_' + textLang.code], field)"

        @keyup.enter="saveCallback"
        class="mb-2"
      />
    </div>
    <v-textarea
      v-else-if="field.canRead && field.info.stringRows"
      v-model="value[field.fieldName]"
      :label="labelText"
      :prepend-icon="field.fieldName.toLowerCase().includes('icon') ? (value[field.fieldName] || '-') : ''"
      hide-details

      :dense="cs.inputDense"
      :outlined="cs.inputOutlined"
      :filled="cs.inputFilled"
      :background-color="fieldBackgroundColor(value[field.fieldName], field)"

      placeholder=""
      :rows="field.info.stringRows"
      :disabled="!field.canEdit"
      :append-icon="field.info.password ? (showPassword ? 'fa-eye' : 'fa-eye-slash') : ''"
      :type="field.info.password ? (showPassword ? 'text' : 'password') : 'text'"
      @click:append="showPassword = !showPassword"
    />
    <v-text-field
      v-else-if="field.canRead"
      v-model="value[field.fieldName]"
      :label="labelText"
      :prepend-icon="field.fieldName.toLowerCase().includes('icon') ? (value[field.fieldName] || '-') : ''"
      hide-details

      :outlined="cs.inputOutlined"
      :filled="cs.inputFilled"
      :rounded="cs.inputRounded"
      :dense="cs.inputDense"
      :background-color="fieldBackgroundColor(value[field.fieldName], field)"

      placeholder=""
      :disabled="!field.canEdit"
      :append-icon="field.info.password ? (showPassword ? 'fa-eye' : 'fa-eye-slash') : ''"
      :type="field.info.password ? (showPassword ? 'text' : 'password') : 'text'"
      :autofocus="field.info.autofocus"
      @keyup.enter="saveCallback"
      @click:append="showPassword = !showPassword"
    />
  </div>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormInput',

  props: {
    ...formElementProps
  },

  data: () => {
    return {
      showPassword: false
    }
  },

  created () {
    // console.log('this.field', this.field)
  },

  computed: {
    ...sharedComputed
  },

  methods: {
    ...sharedMethods,


    saveCallback2 () {
      this.saveCallback()
    }
  }
}
</script>
